import { useState, useEffect } from 'react';
import { Control } from 'react-hook-form';
import { useAppDispatch } from '../../../../store/hook';
import { openAlert } from '../../../../store/features/modalSlice';
import instance from '../../../../api/axios/utils.ts/instance';
import { uidRegExp } from '../../../../api/utils/util-func';
import { SIGNUP_MESSAGES } from '../constants';
import { UserDTO } from '../types';

export const useUidDuplicateCheck = (
  uid: string,
  control: Control<UserDTO>,
  clearErrors: () => void,
) => {
  const dispatch = useAppDispatch();
  const [checkDuplicate, setCheckDuplicate] = useState<boolean>(false);

  const alert = (message: string) => dispatch(openAlert({ message }));

  // uid가 변경되면 중복확인 상태 초기화
  useEffect(() => {
    if (checkDuplicate) {
      setCheckDuplicate(false);
    }
  }, [uid]);

  const getIdCheck = async () => {
    if (!uid) {
      alert(SIGNUP_MESSAGES.UID_REQUIRED);
      control.setError('uid', { message: SIGNUP_MESSAGES.UID_REQUIRED });
      return;
    }

    if (!uid.match(uidRegExp)) {
      alert(SIGNUP_MESSAGES.UID_PATTERN_INVALID);
      control.setError('uid', { message: SIGNUP_MESSAGES.UID_PATTERN_INVALID });
      return;
    }

    const response = await instance.get('/v1/user/uid-check', {
      params: { uid },
    });
    const data = response.data;

    if (data.statusCode === 200) {
      if (data.data.existUser === false) {
        setCheckDuplicate(true);
        alert(SIGNUP_MESSAGES.UID_AVAILABLE);
        clearErrors();
      } else {
        setCheckDuplicate(false);
        alert(SIGNUP_MESSAGES.UID_DUPLICATE);
        control.setError('uid', { message: SIGNUP_MESSAGES.UID_DUPLICATE });
      }
    } else {
      alert(SIGNUP_MESSAGES.UID_CHECK_FAILED);
    }
  };

  return {
    checkDuplicate,
    getIdCheck,
  };
};
